import { createSpinner } from './helpers';

const setErrors = (fileInput, input, fieldset) => {
  fileInput.value = '';
  input.value = '';
  fieldset.querySelector('.form-field__wrapper').classList.remove('img--uploaded');
  fieldset.classList.remove('has-error');
  // fieldset.setAttribute(
  //   'data-error',
  //   'Nieprawidłowy plik (np. za duży lub w złym formacie)',
  // );
};

export const uploadPhoto = (form, id, max, idUrl) => {
  const uploadInput = form.querySelector(id);
  const uploadInputUrl = form.querySelector(idUrl);
  const uploadWrapper = form.querySelector('.form-field__wrapper');

  const randomFileName = () => {
    let d = new Date();
    d = d.toISOString().substring(0, 19).replace(/[:T-]/gi, '');
    return `${d}-${String(Math.random().toString(34).substring(2, 32))}`;
  };

  const makeFormData = (contestId, file, fileName) => {
    const data = new FormData();
    data.append('contest_id', contestId);
    data.append('file', file, fileName);
    return data;
  };

  uploadInput.addEventListener('dragover', () => {
    uploadWrapper.classList.add('is-dragover');
  });
  uploadInput.addEventListener('dragenter', () => {
    uploadWrapper.classList.add('is-dragover');
  });
  uploadInput.addEventListener('dragleave', () => {
    uploadWrapper.classList.remove('is-dragover');
  });
  uploadInput.addEventListener('dragend', () => {
    uploadWrapper.classList.remove('is-dragover');
  });
  uploadInput.addEventListener('drop', () => {
    uploadWrapper.classList.remove('is-dragover');
  });

  uploadInput.addEventListener('change', function () {
    const { files } = this;
    if (files.length) {
      if (files[0].size > max * 1000 * 1024) {
        uploadWrapper.classList.add('wrong-size');
        setTimeout(() => {
          uploadWrapper.classList.remove('wrong-size');
        }, 3000);
        if (form.querySelector('.img-preview__wrapper')) {
          form.querySelector('.img-preview__wrapper').remove();
        }
        setErrors(this, uploadInputUrl, uploadWrapper.closest('fieldset'));
        return;
      }

      createSpinner(uploadWrapper, false);
      const data = makeFormData(form.getAttribute('data-contest-id'), files[0], randomFileName());

      /* FORMULARZ */

      (async () => {
        try {
          const response = await (await fetch('https://contests-upload.wp.pl/v2/fu', {
            method: 'POST',
            body: data,
          })).json();
          const imageUrl = `https:${response.url}`;
          uploadInputUrl.value = imageUrl;
          uploadWrapper.classList.add('img--uploaded');
          uploadWrapper.closest('fieldset').classList.remove('has-error');
          if (form.querySelector('.img-preview__wrapper')) {
            form.querySelector('.img-preview__wrapper').remove();
          }
          const imgPreviewWrapper = document.createElement('div');
          imgPreviewWrapper.classList.add('img-preview__wrapper');
          const imgPreview = document.createElement('img');
          const imgPreviewButton = document.createElement('button');
          imgPreviewWrapper.appendChild(imgPreview);
          imgPreviewWrapper.appendChild(imgPreviewButton);
          imgPreview.src = imageUrl;
          if (uploadWrapper.querySelector('.spinner-wrapper')) {
            uploadWrapper.querySelector('.spinner-wrapper').remove();
            uploadInput.disabled = false;
            uploadInputUrl.disabled = false;
          }
          uploadWrapper.appendChild(imgPreviewWrapper);
          imgPreviewButton.addEventListener('click', () => {
            imgPreviewWrapper.remove();
            setErrors(uploadInput, uploadInputUrl, uploadWrapper.closest('fieldset'));
          });
        } catch (err) {
          console.log('Error:', err);
        }
      })();

      /* KONIEC FORMULARZA */
    }
  });
};
